/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import productService from "../../services/products";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../reducers/userSlice";
import { selectCompany } from "../../../reducers/companySlice";
import { loadingOff, loadingOn } from "../../../reducers/uiSlice";

const useGetProducts = (company, token, deps = []) => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getProducts = async () => {
      setIsLoading(true);
      dispatch(loadingOn());
      try {
        const fetchProducts = await productService.getProductByIdCompany(
          company?._id,
          token
        );
        if (fetchProducts) {
          setProducts(fetchProducts);
        }
      } catch (error) {
        console.log("error trying to fetch products", error);
      } finally {
        setIsLoading(false);
        dispatch(loadingOff());
      }
    };

    if (company?._id?.length) getProducts();
  }, [company?._id?.length, ...deps]);

  return { products, isLoading };
};

export const useGetPaginateProducts = (
  limit,
  page,
  order,
  orderBy,
  searchText,
  searchField,
  deps = []
) => {
  const [products, setProducts] = useState({
    count: 0,
    hasNextPage: false,
    hasPrevPage: false,
    items: [],
    limit: 20,
    next: null,
    page: 1,
    pageCount: 1,
    pagingCounter: 1,
    prev: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(selectUser);
  const company = useSelector(selectCompany);
  const dispatch = useDispatch();

  useEffect(() => {
    const getProducts = async () => {
      setIsLoading(true);
      dispatch(loadingOn());

      try {
        const fetchProducts = await productService.getPaginateProducts(
          company._id,
          limit,
          page,
          order,
          orderBy,
          searchText,
          searchField,
          user?.token
        );
        if (fetchProducts) {
          setProducts(fetchProducts);
        }
      } catch (error) {
        console.log("error trying to fetch products", error);
      } finally {
        dispatch(loadingOff());
        setIsLoading(false);
      }
    };

    if (company._id?.length) getProducts();
  }, [
    company._id?.length,
    limit,
    page,
    order?.length,
    orderBy?.length,
    searchText?.length,
    searchField?.length,
    ...deps,
  ]);

  return { products, isLoading };
};

export const useGetSingleProductById = (productId, deps = []) => {
  const [product, setProduct] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getSingleProduct = async () => {
      setIsLoading(true);

      try {
        const fetchProducts = await productService.getProductById(productId);
        if (fetchProducts) {
          setProduct(fetchProducts);
        }
      } catch (error) {
        console.log("error trying to fetch product", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (productId && productId !== "") {
      getSingleProduct();
    }
  }, [productId, ...deps]);

  return { product, isLoading };
};

export default useGetProducts;
